<template>
  <div class="content">
    <div class="container-fluid">
      <div class="d-flex justify-content-center p-4">
        <card class="col-md-4">
          <h3 slot="header" class="card-title">Cadastro</h3>
          <form action="#"></form>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "Register"
    };
  }
};
</script>

<style></style>
